import spacedContentStyles from './spaced-content.module.css';

interface SpacedContentProps {}

const SpacedContent: React.FC<SpacedContentProps> = ({ children }) => {
    return <div className={spacedContentStyles.spacedContent}>{children}</div>;
};

export default SpacedContent;
